"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedValue = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("../../../utils");

var _FormattedValue = require("./FormattedValue.style");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.number.isRequired
} : {};

const FormattedValue = ({
  children
}) => {
  return (0, _core.jsx)(_FormattedValue.Container, {
    "data-testid": "formatted-value"
  }, (0, _core.jsx)(_FormattedValue.Container.Value, {
    weight: "xs"
  }, (0, _utils.getValue)(children)), (0, _core.jsx)(_FormattedValue.Container.Exponent, null, (0, _utils.getExponent)(children)));
};

exports.FormattedValue = FormattedValue;
process.env.NODE_ENV !== "production" ? FormattedValue.propTypes = propTypes : void 0;
FormattedValue.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FormattedValue",
  "props": {
    "children": {
      "type": {
        "name": "number"
      },
      "required": true,
      "description": ""
    }
  }
};